<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';

const VisualCheckType = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  INCONCLUSIVE: 'INCONCLUSIVE',
};

const BadgePropertiesEnum = {
  [VisualCheckType.FAIL]: {
    label: 'Fail',
    colour: iBadgeColours.ERROR,
    icon: 'small-alert-triangle',
  },
  [VisualCheckType.INCONCLUSIVE]: {
    label: 'Inconclusive',
    colour: iBadgeColours.WARNING,
    icon: 'small-alert-circle',
  },
  [VisualCheckType.PASS]: {
    label: 'Pass',
    colour: iBadgeColours.SUCCESS,
    icon: 'small-check-circle',
  },
};

export default {
  name: 'document-review-agent-report-visual-check',
  components: { iBadge },
  props: {
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    result: {
      type: String,
      required: true,
    },
    rationale: {
      type: String,
      required: true,
    },
  },
  data() {
    return { iBadgeColours };
  },
  computed: {
    badgeProperties() {
      return BadgePropertiesEnum[this.result];
    },
    pillClass() {
      return `report-visual-check__title-result i-text-subheading-3 i-text-neutral-120 report-visual-check__title-result--${this.result.toLowerCase()}`;
    },
  },
};
</script>

<template>
  <div class="report-visual-check">
    <div :class="pillClass">
      <div>{{ title }}</div>
      <i-badge
        :colour="badgeProperties.colour"
        :label="badgeProperties.label"
        :has-leading-icon="true"
        :interactable="true"
      ></i-badge>
    </div>
    <div
      class="report-visual-check__rationale i-text-body-3 i-text-neutral-120"
    >
      <div class="report-visual-check__rationale-title i-text-subheading-3">
        Rationale
      </div>
      {{ rationale }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.report-visual-check {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: map-get($increments, 8);
  width: 100%;

  &__title-result {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: $base-unit * 1.5;
    padding: map-get($increments, 4) map-get($increments, 8);
  }

  &__title-result--pass {
    border-color: $light-success-70;
  }

  &__title-result--fail {
    border-color: $light-error-70;
  }

  &__title-result--inconclusive {
    border-color: $light-warning-70;
  }

  &__rationale {
    display: flex;
    flex-direction: column;
    border: 1px solid $light-neutral-70;
    border-radius: $base-unit * 1.5;
    padding: map-get($increments, 8);
    width: 100%;
  }

  &__rationale-title {
    margin-bottom: map-get($increments, 2);
  }
}
</style>
